export default {
  "fr": {
    "question": {
      "actions": {
        "addDocuments": "Ajouter documents",
        "cancel": "Annuler",
        "createQuestion": "Nouvelle question",
        "delete": "Supprimer",
        "deleteDocuments": "Supprimer documents",
        "edit": "Modifier",
        "new": "Nouvelle question",
        "save": "Enregistrer"
      },
      "attributes": {
        "answer": "Réponse",
        "documents": "Documents / Images",
        "name": "Question",
        "question": "Question"
      },
      "labels": {
        "editQuestion": "Modifier la question",
        "newQuestion": "Nouvelle question"
      },
      "toasts": {
        "create": "Question créée",
        "delete": "Question supprimée",
        "update": "Question modifiée"
      },
      "validation": {
        "needAnswer": "Réponse requise",
        "needQuestion": "Question requise"
      }
    }
  }
}